import script from "./RequestDetailsView.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestDetailsView.vue?vue&type=script&setup=true&lang=js"

import "./RequestDetailsView.vue?vue&type=style&index=0&id=255b601c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-255b601c"]])

export default __exports__